import { combineReducers } from 'redux';

import {
    REQUEST_FIND_ACTIVE_CONTEST,
    RECEIVE_FIND_ACTIVE_CONTEST,
    FAILURE_FIND_ACTIVE_CONTEST,
    REQUEST_SUBMIT_GIVEAWAY_PARTICIPATION,
    SUCCESS_SUBMIT_GIVEAWAY_PARTICIPATION,
    FAILURE_SUBMIT_GIVEAWAY_PARTICIPATION,
    RESET_FORM_SUBMIT_GIVEAWAY_PARTICIPATION,
    REQUEST_IS_USER_REGISTERED_TO_CONTEST,
    RECEIVE_IS_USER_REGISTERED_TO_CONTEST,
    FAILURE_IS_USER_REGISTERED_TO_CONTEST
} from './constants';

const contest = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_FIND_ACTIVE_CONTEST:
            return action.response.payload;
        default:
            return state;
    }
};

const contestFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_FIND_ACTIVE_CONTEST:
            return true;
        case FAILURE_FIND_ACTIVE_CONTEST:
        case RECEIVE_FIND_ACTIVE_CONTEST:
            return false;
        default:
            return state;
    }
};

const contestError = (state = '', action) => {
    switch (action.type) {
        case FAILURE_FIND_ACTIVE_CONTEST:
            return action.response.message;
        case REQUEST_FIND_ACTIVE_CONTEST:
        case RECEIVE_FIND_ACTIVE_CONTEST:
            return '';
        default:
            return state;
    }
};

const successGiveawayParticipationSubmit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_SUBMIT_GIVEAWAY_PARTICIPATION:
            return true;
        case REQUEST_SUBMIT_GIVEAWAY_PARTICIPATION:
        case FAILURE_SUBMIT_GIVEAWAY_PARTICIPATION:
        case RESET_FORM_SUBMIT_GIVEAWAY_PARTICIPATION:
            return false;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_SUBMIT_GIVEAWAY_PARTICIPATION:
            return true;
        case FAILURE_SUBMIT_GIVEAWAY_PARTICIPATION:
        case SUCCESS_SUBMIT_GIVEAWAY_PARTICIPATION:
        case RESET_FORM_SUBMIT_GIVEAWAY_PARTICIPATION:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_SUBMIT_GIVEAWAY_PARTICIPATION:
            return action.response.message;
        case REQUEST_SUBMIT_GIVEAWAY_PARTICIPATION:
        case SUCCESS_SUBMIT_GIVEAWAY_PARTICIPATION:
        case RESET_FORM_SUBMIT_GIVEAWAY_PARTICIPATION:
            return '';
        default:
            return state;
    }
};

const registered = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_IS_USER_REGISTERED_TO_CONTEST:
            return action.response.payload;
        default:
            return state;
    }
};

const registeredFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_IS_USER_REGISTERED_TO_CONTEST:
            return true;
        case FAILURE_IS_USER_REGISTERED_TO_CONTEST:
        case RECEIVE_IS_USER_REGISTERED_TO_CONTEST:
            return false;
        default:
            return state;
    }
};

const registeredError = (state = '', action) => {
    switch (action.type) {
        case FAILURE_IS_USER_REGISTERED_TO_CONTEST:
            return action.response.message;
        case REQUEST_IS_USER_REGISTERED_TO_CONTEST:
        case RECEIVE_IS_USER_REGISTERED_TO_CONTEST:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    contest,
    contestFetching,
    contestError,
    successGiveawayParticipationSubmit,
    fetching,
    error,
    registered,
    registeredFetching,
    registeredError
});



// WEBPACK FOOTER //
// ./src/services/giveaway/reducer.js